import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import Image from 'next/image';
import * as React from 'react';

export interface ClaimContainerProps {
  image?: string;
  title: string;
  subTitle?: string;
  description?: string;
  error?: string;
}
const ClaimContainer = ({ image, title, subTitle, description, error }: ClaimContainerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '0 0 5px 0 ',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {image && (
        <Image
          src={image}
          style={{
            marginBottom: '25px',
            maxWidth: '50%',
            minHeight: '130px',
            objectFit: 'contain'
          }}
          alt="product_image"
        />
      )}
      {subTitle && (
        <Typography
          component="h4"
          align="center"
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            marginBottom: '10px',
            fontFamily: theme?.MojitoClaim?.font?.secondary
          }}
        >
          {subTitle}
        </Typography>
      )}
      <Typography
        component="h4"
        align="center"
        sx={{
          fontFamily: theme?.MojitoClaim?.font?.primary,
          fontWeight: 500,
          fontSize: '24px',
          marginBottom: '10px'
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontFamily: theme?.MojitoClaim?.font?.secondary,
            fontSize: '16px',
            fontWeight: 400,
            wordWrap: 'break-word',
            maxWidth: '100%',
            color: error ? theme?.MojitoClaim?.error : theme?.ClaimTemplate?.collectionHeaderColor
          }}
          align="center"
        >
          {parse(description)}
        </Typography>
      )}
    </Box>
  );
};

export default ClaimContainer;
